import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col overflow-hidden" data-id="element-250">
      {/* Background Image - City */}
      <div className="absolute inset-0 bottom-32 md:bottom-48" data-id="element-251">
        <img src="https://cdn.magicpatterns.com/uploads/su4Z4WSZkXV8KdGE2UKdZ1/freepik__talk__42723.png" alt="" className="w-full h-full object-cover" data-id="element-252" />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0F2A]/70 via-[#0A0F2A]/50 to-[#0A0F2A]" data-id="element-253" />
      </div>

      {/* Solid background for trust bar area */}
      <div className="absolute bottom-0 left-0 right-0 h-32 md:h-48 bg-[#0A0F2A]" data-id="element-254" />

      {/* Content */}
      <div className="relative z-10 flex-1 flex flex-col max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 w-full pt-20 md:pt-28 pb-8 md:pb-12" data-id="element-255">
        {/* Main Title - Centered at top */}
        <motion.div className="text-center mb-6 md:mb-16" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-256">
          <h1 className="text-4xl sm:text-5xl md:text-8xl lg:text-9xl font-black tracking-tight" data-id="element-257">
            ШЛЯХ{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-500" data-id="element-258">
              ЛІДЕРА
            </span>
          </h1>
        </motion.div>

        {/* Two Column Layout */}
        <div className="flex-1 grid lg:grid-cols-2 gap-4 md:gap-12 items-start" data-id="element-259">
          {/* Left Column */}
          <motion.div className="space-y-4 md:space-y-6" initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-260">
            {/* Info Badges - Only 2 badges, distributed evenly */}
            <div className="flex justify-center lg:justify-center gap-3 md:gap-6 mb-4 md:mb-6" data-id="element-261">
              <div className="inline-flex items-center justify-center gap-1.5 md:gap-2 bg-black/30 backdrop-blur-sm border border-white/20 rounded-full px-3 md:px-5 py-1.5 md:py-2 whitespace-nowrap" data-id="element-262">
                <span className="text-gray-300 text-xs md:text-sm" data-id="element-263">
                  Формат:
                </span>
                <span className="text-white font-bold text-xs md:text-sm" data-id="element-264">
                  онлайн · 6 тижнів
                </span>
              </div>
              <div className="inline-flex items-center justify-center gap-1.5 md:gap-2 bg-black/30 backdrop-blur-sm border border-white/20 rounded-full px-3 md:px-5 py-1.5 md:py-2 whitespace-nowrap" data-id="element-265">
                <span className="text-gray-300 text-xs md:text-sm" data-id="element-266">Місць:</span>
                <span className="text-white font-bold text-xs md:text-sm" data-id="element-267">
                  обмежено
                </span>
              </div>
            </div>

            {/* Main Content Block */}
            <div className="bg-black/40 backdrop-blur-md border border-white/10 rounded-xl md:rounded-2xl p-4 md:p-8" data-id="element-268">
              {/* New Title and Subtitle */}
              <h2 className="text-lg sm:text-xl md:text-3xl font-bold text-white mb-1 md:mb-2" data-id="element-269">
                Formula Growth Acquisition
              </h2>
              <p className="text-sm md:text-lg text-gray-300 mb-4 md:mb-6" data-id="element-270">
                Маркетинг-система для стабільного залучення клієнтів
              </p>

              <p className="text-blue-400 font-medium text-[10px] md:text-sm uppercase tracking-wider mb-3 md:mb-4" data-id="element-271">
                Групове онлайн-навчання для підприємців від ARMAR Solutions
              </p>

              <h3 className="text-base md:text-xl font-bold text-white mb-3 md:mb-4" data-id="element-272">
                За 6 тижнів Ви:
              </h3>

              <ul className="space-y-2 md:space-y-3 mb-4 md:mb-6" data-id="element-273">
                {['Навчитеся самостійно приймати маркетингові рішення', 'Визначите ключові точки зростання бізнесу', 'Побудуєте системну модель залучення клієнтів', 'Опануєте ментальні моделі лідера без позиції «жертви обставин»', 'Зрозумієте фінанси в маркетингу та ключові показники юніт-економіки', 'Знайдете слабкі місця та перетворите їх на точки росту'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-274">
                    <div className="w-1 h-1 md:w-1.5 md:h-1.5 rounded-full bg-blue-400 mt-1.5 md:mt-2 shrink-0" data-id="element-275" />
                    <span className="text-gray-200 text-xs md:text-base" data-id="element-276">
                      {item}
                    </span>
                  </li>)}
              </ul>

              {/* CTA Buttons - Stack on mobile */}
              <div className="flex flex-col sm:flex-row gap-2 md:gap-3" data-id="element-277">
                <Button href="#tariffs" size="md" withArrow className="text-sm md:text-base" data-id="element-278">
                  Доєднатися до програми
                </Button>
                <Button href="#program" variant="outline" size="md" className="text-sm md:text-base" data-id="element-279">
                  Структура навчання
                </Button>
              </div>
            </div>

            {/* Trust Bar - Under left block, centered and full width */}
            <motion.div className="pt-2 md:pt-4 text-center w-full" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.5
          }} data-id="element-280">
              <p className="text-white text-xs md:text-lg mb-2 md:mb-3" data-id="element-281">
                Методологія побудована на практичному досвіді ARMAR Solutions
              </p>
              <div className="flex flex-wrap justify-center gap-x-2 md:gap-x-3 gap-y-1 text-white text-xs md:text-lg" data-id="element-282">
                {['Philip Morris', 'BAT', 'PUMB', 'МТБ Банк', 'P&G'].map((brand, index, arr) => <span key={brand} className="font-semibold" data-id="element-283">
                      {brand}
                      {index < arr.length - 1 && <span className="ml-2 md:ml-3" data-id="element-284">·</span>}
                    </span>)}
              </div>
              <p className="text-white text-xs md:text-lg mt-2 md:mt-3 font-medium" data-id="element-285">
                500+ реалізованих проєктів
              </p>
            </motion.div>
          </motion.div>

          {/* Right Column - Speaker Photo with overlay info - Hidden on mobile, visible on lg */}
          <motion.div className="relative hidden lg:flex lg:flex-col lg:justify-between" initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-286">
            <div className="bg-black/40 backdrop-blur-md border border-white/10 rounded-2xl p-3 lg:p-4 h-full flex flex-col" data-id="element-287">
              {/* Nikita Photo with overlay text */}
              <div className="relative flex-1" data-id="element-288">
                <div className="aspect-[4/5] w-full rounded-xl overflow-hidden border border-white/10 relative" data-id="element-289">
                  <img src="https://cdn.magicpatterns.com/uploads/pWdoMNheCiy1NRvPTcEaBJ/Frame_3.jpg" alt="Нікіта Шпірт" className="w-full h-full object-cover object-top" data-id="element-290" />
                  {/* Gradient overlay for text readability */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" data-id="element-291" />

                  {/* Speaker Info - overlaid on photo */}
                  <div className="absolute bottom-4 left-4 right-4 text-left" data-id="element-292">
                    <h3 className="text-2xl font-bold text-white mb-1" data-id="element-293">
                      Нікіта Шпірт
                    </h3>
                    <p className="text-blue-400 font-medium text-sm" data-id="element-294">
                      Founder & CEO ARMAR Solutions
                    </p>
                  </div>
                </div>
              </div>

              {/* Quote - larger text */}
              <blockquote className="relative px-2 mt-4" data-id="element-295">
                <div className="absolute -top-2 -left-1 text-4xl text-blue-500/40 font-serif" data-id="element-296">
                  "
                </div>
                <p className="text-gray-200 italic pl-6 pr-4 leading-relaxed text-base md:text-lg" data-id="element-297">
                  Ми покажемо, як працює маркетинг на рівні системи, а не
                  окремих інструментів, гіпотез чи тактичних рішень.
                </p>
                <div className="absolute -bottom-2 right-2 text-4xl text-blue-500/40 font-serif" data-id="element-298">
                  "
                </div>
              </blockquote>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}